import type { Card, Suit } from '../../engine/card.js';
import { CARD_W, CARD_H } from './types.js';

/**
 * Spritesheet layout (matches /classic/spritesheet.png used by the original
 * vanilla Klondike): 13 ranks across (Ace=col 0, ..., King=col 12), suits
 * down rows in the order clubs/diamonds/hearts/spades, and 12 card backs at
 * row 4 (cols 1-12). Card width 71, card height 96.
 */
const SUIT_ROW: Record<Suit, number> = {
  clubs: 0,
  diamonds: 1,
  hearts: 2,
  spades: 3,
};

export function faceUpBackgroundPosition(card: Card): string {
  const x = -(card.rank - 1) * CARD_W;
  const y = -SUIT_ROW[card.suit] * CARD_H;
  return `${x}px ${y}px`;
}

let backStyleCache: string | null = null;

/** Pick one card-back style for the whole game (cached per page load). */
export function backBackgroundPosition(): string {
  if (backStyleCache) return backStyleCache;
  const style = 1 + Math.floor(Math.random() * 12);
  backStyleCache = `${-style * CARD_W}px ${-4 * CARD_H}px`;
  return backStyleCache;
}

export interface CardEl {
  el: HTMLDivElement;
  card: Card;
}

export function createCardEl(card: Card): CardEl {
  const el = document.createElement('div');
  el.className = 'cl2-card';
  el.dataset.cardId = card.id;
  el.style.backgroundPosition = card.faceUp
    ? faceUpBackgroundPosition(card)
    : backBackgroundPosition();
  el.dataset.faceUp = card.faceUp ? '1' : '0';
  return { el, card };
}

export function setCardFace(el: HTMLDivElement, card: Card): void {
  el.style.backgroundPosition = card.faceUp
    ? faceUpBackgroundPosition(card)
    : backBackgroundPosition();
  el.dataset.faceUp = card.faceUp ? '1' : '0';
}
